export default __webpack_public_path__ + "static/media/language-rocketDAO-accelerator.cae4f5e2.svg";